<template>
  <div class="honors-content">
    <div class="title">公司荣誉</div>
    <div class="message">
      积淀专业立标杆，深耕服务赢口碑
    </div>
    <div class="honors-row">
      <div class="honors-item" v-for="(item, index) in newsList" :key="index">
        <div class="img-box">
          <img class="img" :src="item.cover" alt="" />
        </div>
        <div class="honors-title">{{ item.articleName }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getArticlePage } from '@/api/home/home.js'
export default {
  name: 'Honors',
  data() {
    return {
      newsList: [] // 荣誉数据列表
    }
  },
  created() {
    this.getArticlePage(111)
  },
  methods: {
    //获取文章列表
    getArticlePage(code) {
      getArticlePage({
        page: 1,
        limit: 1000,
        categoryCode: code
      }).then((res) => {
        if (!res.data) return
        this.newsList = res.data.list
      })
    }
  }
}
</script>

<style scoped lang="scss">
.honors-content {
  display: flex;
  flex-direction: column;
  margin: 64px auto;
  width: 1472px;
  .honors-row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-top: 64px;
    gap: 36px 36px;
    .honors-item {
      border: 0 solid #e5e7eb;
      background: #fff;
      box-shadow: -3px -7px 9.1px -4px rgba(0, 0, 0, 0.02),
        0 10px 15px -3px rgba(0, 0, 0, 0.06);
      width: 341px;
      height: 380px;
      padding: 16px 24px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      position: relative;
      top: 0;
      transition: all 0.3s ease-in-out;
      .honors-title {
        width: 257px;
        color: #111;
        font-size: 20px;
        font-weight: 600;
        margin: 16px auto 0;
        height: 60px;
        line-height: 30px;
      }
      .img-box {
        width: 257px;
        height: 206px;
        background: #f9fafb;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .img {
          width: 178px;
          height: 118px;
          margin: auto;
          object-fit: contain;
        }
      }
    }
    .honors-item:hover {
      top: -14px;
    }
  }
  .message {
    color: #5c5c5c;
    font-size: 18px;
    font-weight: 400;
    height: 28px;
    line-height: 28px;
    text-align: center;
    margin-top: 24px;
  }
  .title {
    color: #111;
    font-size: 40px;
    font-weight: 600;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
}

// 手机端css
.mobile-content {
  .honors-content {
    margin: 32px auto;
    width: 345px;
    .honors-row {
      margin-top: 32px;
      gap: 20px 20px;
      .honors-item {
        width: calc(100% / 2 - 10px);
        height: auto;
        padding: 10px 12px;
        .honors-title {
          height: 40px;
          line-height: 20px;
          font-size: 15px;
          width: 100%;
          margin: 10px auto 0;
        }
        .img-box {
          width: 100%;
          height: 130px;
          .img {
            width: 120px;
            height: 100px;
          }
        }
      }
      .honors-item:hover {
        top: -7px;
      }
    }
    .message {
      font-size: 14px;
      line-height: 20px;
      height: auto;
      margin-top: 12px;
    }
    .title {
      font-size: 24px;
      line-height: 35px;
      height: auto;
    }
  }
}
</style>
